import React from "react";
import { Link } from "react-router-dom";
import Icon from "../components/AppIcon";
import Header from "../components/ui/Header";
import Footer from "../components/ui/Footer";

const NotFound = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow flex items-center justify-center py-16 px-4">
        <div className="max-w-md w-full text-center">
          <div className="mb-6 text-primary">
            <Icon name="FileQuestion" size={64} />
          </div>
          <h1 className="text-4xl font-display font-bold text-text-primary mb-4">
            Page Not Found
          </h1>
          <p className="text-text-secondary mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <Link
            to="/products-home-page"
            className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
          >
            <Icon name="ArrowLeft" className="mr-2" size={18} />
            Back to Products
          </Link>
        </div>
      </main>
      <Footer variant="minimal" />
    </div>
  );
};

export default NotFound;